// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1jTeg","list":"styles_list__1A3u5"};